export interface HeatMap{
  x: number;
  y: number;
  count: number;
}
export enum HeatMapType {
  FORKLIFT_POSITION = 'FORKLIFT_POSITION'
}
